import {Card, CardContent, CardMedia, Stack, Typography} from "@mui/material";
import {DEFAULT_IMAGE_BLACK_URL, LOADING_IMAGE_URL, pickImageByClass, pickImageUrl} from "../../../utils/workUtil";
import {workAttrList} from "../types/workForm";
import {MODEL_BG_COLOR} from "../../../constants/work";
import {WorkClassDocument} from "../../../types/pj1dbApiWork";
import {FindModelResponse} from "../../../types/pj1dbApiHandling";

export interface WorkListItemProps {
  work: WorkClassDocument;
  // eslint-disable-next-line react/require-default-props
  representativeModels?: FindModelResponse[];
  // eslint-disable-next-line react/require-default-props
  isLoading?: boolean;
}

export default function WorkListItem(props: WorkListItemProps) {
  const image = props.representativeModels
    ? pickImageByClass(props.work, props.representativeModels)
    : pickImageUrl(props.work);
  const showLoading = props.isLoading === true && image === DEFAULT_IMAGE_BLACK_URL;

  return (
    <Card sx={{p: 0, m: 0, width: 240, height: '100%'}}>
      <CardMedia
        component="img"
        height="145"
        image={showLoading ? LOADING_IMAGE_URL : image}
        alt={props.work.attr[workAttrList.nameJp.key]}
        sx={{objectFit: "scale-down", backgroundColor: MODEL_BG_COLOR}}
      />
      <CardContent sx={{pt: 1, px: 1}}>
        <Stack gap={1}>
          <Typography variant="subtitle2" component='p' sx={{overflowWrap: 'break-word'}}>
            対象物名：<br/>
            {props.work.attr[workAttrList.nameJp.key]}
          </Typography>
          <Typography variant="subtitle2" component='p' sx={{color: "#888"}}>
            JANコード/部品コード：<br/>
            {props.work.attr[workAttrList.code.key]}
          </Typography>
        </Stack>
      </CardContent>
    </Card>
  )
}
